<div class="quetion-select-widget">
  <lib-question-hint [hint]="'SLIDES.select_correct_answer_plural' | translate:{count: correctAnswersCount}"></lib-question-hint>

  <div class="question-options-list" [class.justify-content-center]="answers.length < 3">
    @for (item of answers; track item; let i = $index) {
      <lib-question-option
        class="animate__animated"
        [ngClass]="animation"
        [style.animationDelay.ms]="animationDelay + i * 200"
        (click)="select(item.hash)"
        [index]="i"
        [text]="item.text"
        [mediaImage]="item.mediaImage"
        [mediaType]="mediaType"
        [mediaRatio]="mediaRatio"
        [visited]="item.visited"
        [active]="selectedHash.indexOf(item.hash) !== -1">
      </lib-question-option>
    }
  </div>
</div>
